export default function ICAOnlineSDK (scriptSrc) {
  let ICAOnlineCartSDKscript = document.createElement('script')
  ICAOnlineCartSDKscript.setAttribute('src', scriptSrc)
  document.body.appendChild(ICAOnlineCartSDKscript)
}